import { CoveragesSliceState } from '../types';

export const coverageSliceInitialState: CoveragesSliceState = {
  data: {
    listings: [],
    pagination: {
      page: 1,
      perPage: 20,
      numberOfItems: 0,
    },
  },
  statuses: {
    isLoading: false,
  },
  savedFiltersForSending: null,
  savedSortingForSending: null,
};
